export default __webpack_public_path__ + "static/media/peep-45.bbd96637.svg";